<!-- 代扣服务费-商家-查看开票信息 -->
<template>
  <div class="agent-invoice-container">
    <!-- 注意事项 -->
    <div class="info-top-panel">
      <h2>注意事项：</h2>
      <p>
        1、请严格按照主体信息和对应金额进行开票。<br />
        2、发票上的价税合计项金额须与待核销金额一致。<br />
        3、纸质发票如需邮寄，具体邮寄费用承担方由合作商与商家商议确认。<br />
        4、开票项目由双方商议确认，开票项目举例：*供电*电费；*经营租赁*场地使用费；*现代服务*服务费；*企业管理服务*服务费
      </p>
    </div>

    <!-- 开票主体信息 -->
    <div
      v-if="!loading && invoiceInfo"
      class="info-main-panel"
    >
      <div class="top-tip">
        开票主体
      </div>
      <div class="info-panel">
        <div class="row">
          <div class="left">
            主体类型
          </div>
          <div class="right">
            {{ titleTypeText }}
          </div>
        </div>
        <div class="row">
          <div class="left">
            名称
          </div>
          <div class="right">
            {{ invoiceInfo.name }}
          </div>
        </div>
        <div
          v-if="invoiceInfo.taxNumber"
          class="row"
        >
          <div class="left">
            税号
          </div>
          <div class="right">
            {{ invoiceInfo.taxNumber }}
          </div>
        </div>
        <div
          v-if="invoiceInfo.registeredAddress"
          class="row"
        >
          <div class="left">
            注册地址
          </div>
          <div class="right">
            {{ invoiceInfo.registeredAddress }}
          </div>
        </div>
        <div
          v-if="invoiceInfo.registeredPhone"
          class="row"
        >
          <div class="left">
            注册电话
          </div>
          <div class="right">
            {{ invoiceInfo.registeredPhone }}
          </div>
        </div>
        <div
          v-if="invoiceInfo.bankName"
          class="row"
        >
          <div class="left">
            开户银行
          </div>
          <div class="right">
            {{ invoiceInfo.bankName }}
          </div>
        </div>
        <div
          v-if="invoiceInfo.bankAccount"
          class="row"
        >
          <div class="left">
            银行账号
          </div>
          <div class="right">
            {{ invoiceInfo.bankAccount }}
          </div>
        </div>
      </div>
    </div>

    <!-- 收票地址信息 -->
    <div
      v-if="!loading && invoiceInfo"
      class="info-main-panel"
    >
      <div class="top-tip">
        收票地址
      </div>
      <div class="info-panel">
        <!-- 纸质发票 -->
        <div>
          <div class="title">
            纸质发票：
          </div>
          <div class="row">
            <div class="left">
              收件人
            </div>
            <div class="right">
              {{ invoiceInfo.paperReceiver || '-' }}
            </div>
          </div>
          <div class="row">
            <div class="left">
              电话
            </div>
            <div class="right">
              {{ invoiceInfo.paperPhone || '-' }}
            </div>
          </div>
          <div class="row">
            <div class="left">
              地址
            </div>
            <div class="right">
              {{ invoiceInfo.paperAddress || '-' }}
            </div>
          </div>
          <div
            v-if="invoiceInfo.paperReceiver && invoiceInfo.paperPhone && invoiceInfo.paperAddress"
            class="single-row"
          >
            <van-button
              type="primary"
              size="small"
              plain
              hairline
              class="copy-btn"
              @click="copyPaperAddress"
            >
              <div class="btn-icon-outer">
                <img
                  class="btn-copy-icon"
                  src="@/assets/img/copy-icon@2x.png"
                />
                一键复制
              </div>
            </van-button>
          </div>
        </div>

        <!-- 电子发票 -->
        <div class="info-gap">
          <div class="title">
            电子发票：
          </div>
          <div class="row">
            <div class="left">
              邮箱
            </div>
            <div class="right">
              {{ invoiceInfo.electronicEmail || '-' }}
            </div>
          </div>
          <div
            v-if="invoiceInfo.electronicEmail"
            class="single-row"
          >
            <van-button
              type="primary"
              size="small"
              plain
              hairline
              class="copy-btn"
              @click="copyEmail"
            >
              <div class="btn-icon-outer">
                <img
                  class="btn-copy-icon"
                  src="@/assets/img/copy-icon@2x.png"
                />
                复制邮箱
              </div>
            </van-button>
          </div>
        </div>
      </div>
    </div>

    <!-- 加载状态 -->
    <div
      v-if="loading"
      class="loading-container"
    >
      <van-loading
        type="spinner"
        size="50px"
      />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VueClipboard from 'vue-clipboard2';
import Loading from 'vant/lib/loading';
import Button from 'vant/lib/button';
import BillApi from '@/api/bill';
import 'vant/lib/loading/style';
import 'vant/lib/button/style';

Vue.use(VueClipboard);

export default {
  name: 'AgentInvoiceInfo',
  components: {
    [Loading.name]: Loading,
    [Button.name]: Button,
  },
  data() {
    return {
      invoiceInfo: null,
      loading: true,
      agentCustomerId: null,
    };
  },
  computed: {
    titleTypeText() {
      if (!this.invoiceInfo) return '-';
      const titleType = this.invoiceInfo.titleType;
      // eslint-disable-next-line
      return titleType === 1 ? '公司' : (titleType === 2 ? '个人/政府事业单位' : '-');
    },
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      // 获取 agentCustomerId 参数
      this.agentCustomerId = this.$route.query.agentCustomerId;

      if (!this.agentCustomerId) {
        this.$dialog.toast('参数错误，缺少合作商ID');
        setTimeout(() => {
          this.$router.go(-1);
        }, 1500);
        return;
      }

      await this.getInvoiceInfo();
      this.loading = false;
    },
    async getInvoiceInfo() {
      try {
        const res = await BillApi.queryAgentInvoiceInfo(this.agentCustomerId);
        if (res.data) {
          this.invoiceInfo = res.data;
        } else {
          this.$dialog.toast(res.message || '获取开票信息失败');
        }
      } catch (error) {
        console.error('Failed to get invoice info:', error);
        this.$dialog.toast('获取开票信息失败，请稍后重试');
      }
    },
    copyPaperAddress() {
      const { paperReceiver, paperPhone, paperAddress } = this.invoiceInfo;
      const addressText = `收件人：${paperReceiver}
电话：${paperPhone}
地址：${paperAddress}`;
      this.$copyText(addressText).then(() => {
        this.$dialog.toast('复制收票地址成功');
      }, () => {
        this.$dialog.toast('复制收票地址失败，请手动选择文案复制');
      });
    },
    copyEmail() {
      const { electronicEmail } = this.invoiceInfo;
      this.$copyText(electronicEmail).then(() => {
        this.$dialog.toast('复制邮箱成功');
      }, () => {
        this.$dialog.toast('复制邮箱失败，请手动选择文案复制');
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.agent-invoice-container {
  padding-bottom: 50px;
  text-align: left;

  .info-top-panel {
    line-height: 37px;
    padding: 12px 28px 36px 36px;
    font-size: 26px;
    background: #FFF;

    h2 {
      color: rgba(0, 0, 0, 0.84);
      height: 37px;
      font-weight: bold;
      margin: 0;
    }

    p {
      margin-top: 12px;
      margin-bottom: 0;
      color: rgba(0, 0, 0, 0.42);
      letter-spacing: 0;
    }
  }

  .top-tip {
    padding: 15px 0 8px;
    margin: 6px 18px;
    font-size: 26px;
    font-weight: bold;
    color: #000000;
    opacity: 0.6;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  }

  .info-panel {
    margin: 12px 18px 0;
    padding: 30px 36px;
    border-radius: 12px;
    background: #FFF;

    .info-gap {
      margin-top: 50px;
    }

    .title {
      margin-left: -15px;
      line-height: 45px;
      font-size: 26px;
      font-weight: bold;
      text-align: left;
      color: rgba(0, 0, 0, 0.84);
      letter-spacing: 0;
    }

    .single-row {
      padding-top: 24px;
      font-size: 26px;
      color: rgba(0, 0, 0, 0.6);
    }

    .row {
      display: flex;
      margin-top: 24px;
      line-height: 37px;
      font-size: 26px;

      &:first-child {
        margin-top: 0;
      }

      .left {
        margin-right: 18px;
        color: rgba(0, 0, 0, 0.42);
        min-width: 100px;
      }

      .right {
        flex: 1;
        color: rgba(0, 0, 0, 0.84);
        text-align: right;
      }
    }
  }

  .copy-btn {
    width: 100%;
    color: rgba(0, 0, 0, 0.84);
    position: relative;
    border: 0;

    &::after {
      content: ' ';
      position: absolute;
      top: 0;
      left: 0;
      width: 200%;
      height: 200%;
      transform: scale(0.5);
      transform-origin: left top;
      box-sizing: border-box;
      border: 1px solid rgba(0, 0, 0, 0.5);
      border-radius: 4px;
      pointer-events: none;
    }
  }

  .btn-icon-outer {
    display: inline-block;
    position: relative;
  }

  .btn-copy-icon {
    position: absolute;
    width: 30px;
    height: 30px;
    left: -42px;
    top: 50%;
    margin-top: -15px;
  }

  .loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
  }
}
</style>
